import readOnlyLayout from "../helpers/readOnlyLayout";

function getView() {
  return readOnlyLayout({
    model: "melhous.other_services",
    activeSearch: false,
    target: "melhous",
    domain: [],
    fields: {
      title: { type: "char" },
      icon: { type: "char" },
      description: { type: "text" },
    },
    list: [{ name: "title" }, { name: "description" }],
    form: [
      { name: "title" },
      { name: "icon" },
      { name: "description", colSpan: "md:col-span-2" },
    ],
  });
}

export default { ctxView: getView };
